import { useStore } from '../../store/useStore';

export const InventoryUI = () => {
    const { inventory, isInventoryOpen } = useStore();

    if (!isInventoryOpen) return null;

    // Create a fixed grid of 20 slots (5x4)
    const slots = Array.from({ length: 20 }, (_, index) => {
        return inventory[index] || null;
    });

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(5px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3000,
            fontFamily: "'Inter', sans-serif",
            pointerEvents: 'auto'
        }}>
            <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                maxWidth: '500px',
                backgroundColor: '#1a1a20',
                border: '2px solid #555',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 20px 50px rgba(0,0,0,0.8)',
                zIndex: 3001
            }}>
                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>
                    <h2 style={{ margin: 0, color: '#e2e2e2', fontSize: '20px', letterSpacing: '1px' }}>INVENTORY</h2>
                    <span style={{ color: '#666', fontSize: '12px' }}>{inventory.length} Items</span>
                </div>

                {/* Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(5, 1fr)',
                    gap: '12px',
                    marginBottom: '20px'
                }}>
                    {slots.map((item, index) => (
                        <div key={index} style={{
                            width: '90px',
                            height: '90px',
                            backgroundColor: '#252530',
                            border: '1px solid #3a3a45',
                            borderRadius: '8px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            transition: 'all 0.2s',
                            cursor: item ? 'pointer' : 'default',
                            boxShadow: 'inset 0 0 10px rgba(0,0,0,0.2)'
                        }}
                            onMouseOver={(e) => {
                                if (item) {
                                    e.currentTarget.style.borderColor = '#646cff';
                                    e.currentTarget.style.backgroundColor = '#2a2a35';
                                }
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.borderColor = '#3a3a45';
                                e.currentTarget.style.backgroundColor = '#252530';
                            }}
                        >
                            {item ? (
                                <>
                                    <div style={{ fontSize: '24px', marginBottom: '4px' }}>📦</div>
                                    <span style={{ fontSize: '10px', color: '#ccc', textAlign: 'center', padding: '0 4px' }}>
                                        {item.name}
                                    </span>
                                </>
                            ) : (
                                <span style={{ fontSize: '12px', color: '#333' }}>{index + 1}</span>
                            )}
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div style={{ textAlign: 'right' }}>
                    <button
                        onClick={() => {
                            console.log('Close button clicked');
                            useStore.getState().toggleInventory();
                        }}
                        style={{
                            padding: '8px 24px',
                            backgroundColor: '#e24a4a',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            pointerEvents: 'auto'
                        }}
                    >
                        CLOSE (I)
                    </button>
                </div>
            </div>
        </div>
    );
};
